import { isNil } from 'lodash';
import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class Step141971Meta extends BaseModel {
  /**
   * @var {boolean}
   */
  useEstateFunds;

  constructor(model = {}) {
    super();

    this.useEstateFunds = model.useEstateFunds;
  }

  get isPaymentSelected() {
    return !isNil(this.useEstateFunds);
  }
}
